<div class="notification-header">
  <h3 class="notification-header__title">{{ `${TRANSLOCO_PREFIX}.notifications` | transloco }}</h3>
  <div class="notification-header__actions">
    <eg-toggle [isChecked]="isShowUnreadOnly" (changes)="onShowUnreadChanged($event)"></eg-toggle>
    <span class="notification-header__actions__info">{{ `${TRANSLOCO_PREFIX}.onlyUnread` | transloco }}</span>
  </div>
</div>

<eg-radio-select [items]="filterOptions" [value]="filterValue" (valueChanged)="onFilterChange($event)"></eg-radio-select>

@if (notificationCenterStore.isLoadingNotifications()) {
  <eg-spinner></eg-spinner>
} @else {
  @if (notificationCenterStore.todayNotifications().length > 0) {
    <div class="notification-section">
      <span class="day-tag">{{ `${TRANSLOCO_PREFIX}.today` | transloco }}</span>

      @for (notification of notificationCenterStore.todayNotifications(); track notification.id) {
        <rmb-notification-item
          [notification]="notification"
          (readHandler)="handleRead($event)"
          (taskHandler)="handleTask($event)"
          (clickNotification)="handleClickNotification($event)"
        ></rmb-notification-item>
      }
    </div>
  }

  @if (notificationCenterStore.yesterdayNotifications().length > 0) {
    <div class="notification-section">
      <span class="day-tag">{{ `${TRANSLOCO_PREFIX}.yesterday` | transloco }}</span>

      @for (notification of notificationCenterStore.yesterdayNotifications(); track notification.id) {
        <rmb-notification-item
          [notification]="notification"
          (readHandler)="handleRead($event)"
          (taskHandler)="handleTask($event)"
          (clickNotification)="handleClickNotification($event)"
        ></rmb-notification-item>
      }
    </div>
  }

  @if (notificationCenterStore.olderNotifications().length > 0) {
    <div class="notification-section">
      <span class="day-tag">{{ `${TRANSLOCO_PREFIX}.older` | transloco }}</span>

      @for (notification of notificationCenterStore.olderNotifications(); track notification.id) {
        <rmb-notification-item
          [notification]="notification"
          (readHandler)="handleRead($event)"
          (taskHandler)="handleTask($event)"
          (clickNotification)="handleClickNotification($event)"
        ></rmb-notification-item>
      }
    </div>
  }
}
